"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SalesFooter = SalesFooter;
exports.SalesFooterContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _footerControls = require("./footer-controls.js");
var _guidesLink = require("./guides-link.js");
var _newsletterSignup = require("./newsletter-signup.js");
var _footerMenu = require("./footer-menu.js");
var _footerLegal = require("./footer-legal.js");
var _index = require("../../elements/other/flexbox/index.js");
var _index2 = _interopRequireDefault(require("../../page-header/other/fixed-banner/index.js"));
const SalesFooterContainer = exports.SalesFooterContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SalesFooterContainer",
  class: "pl-sh1slch"
});

/**
 * Sales Footer
 *
 * @param {Object} props React props
 * @param {Object} props.newsletterSignup Newsletter Signup
 * @param {Object} props.guidesLink Guides Link
 * @param {Object} props.footerBanner Footer Banner
 * @param {Object} props.footerMenu Footer Menu
 * @param {Object} props.footerControls Footer Controls
 * @param {Object} props.footerLegal Footer Legal
 * @returns {React.ReactElement} React HTML element
 * @public
 */
function SalesFooter({
  newsletterSignup,
  guidesLink,
  footerBanner,
  footerMenu,
  footerControls,
  footerLegal
}) {
  return /*#__PURE__*/_react.default.createElement(SalesFooterContainer, null, (newsletterSignup || guidesLink) && /*#__PURE__*/_react.default.createElement(_index.Flexbox, {
    xlEntries: 2,
    desktopEntries: 2,
    tabletEntries: 2,
    mobileEntries: 1,
    isColumn: false,
    contrast: true,
    wrapBehavior: "wrap"
  }, newsletterSignup && /*#__PURE__*/_react.default.createElement(_newsletterSignup.NewsletterSignup, newsletterSignup), guidesLink && /*#__PURE__*/_react.default.createElement(_guidesLink.GuidesLink, guidesLink)), footerBanner && /*#__PURE__*/_react.default.createElement(_index2.default, (0, _extends2.default)({}, footerBanner, {
    icon: null,
    dismissible: false
  })), footerMenu && /*#__PURE__*/_react.default.createElement(_footerMenu.FooterMenu, footerMenu), footerControls && /*#__PURE__*/_react.default.createElement(_footerControls.FooterControls, footerControls), footerLegal && /*#__PURE__*/_react.default.createElement(_footerLegal.FooterLegal, footerLegal));
}
SalesFooter.propTypes = {
  newsletterSignup: _propTypes.default.object,
  guidesLink: _propTypes.default.object,
  footerBanner: _propTypes.default.object,
  footerMenu: _propTypes.default.object,
  footerControls: _propTypes.default.object,
  footerLegal: _propTypes.default.object
};